import project from "./project";

const config = {
  wherewego:
    'https://res.cloudinary.com/wherewego/image/upload/v1648229536/WWG2000%20Site%20Photos/imtdfea4evpn2cdiax5o.svg',
  skillup:
    'https://res.cloudinary.com/wherewego/image/upload/v1653007698/WWG2000%20Site%20Photos/mkfkwyyl4v4nnguujapl.svg',
}
const paysYouIcon = config[project];
export default paysYouIcon;